import { useEffect } from 'react';

/**
 * formGuard — garde « formulaire modifié » partagée entre le chevron retour
 * du Topbar, le bouton Back Android (backAndroid.js) et la fermeture de
 * l'onglet (beforeunload).
 *
 * Un seul formulaire est actif à l'écran à la fois dans l'app : un simple
 * drapeau global suffit (pas de contexte React nécessaire).
 *
 * Usage dans un formulaire :
 *   useFormGuard(Boolean(data.id_client || data.nom));  // dirty ?
 * Le drapeau retombe automatiquement au démontage et quand la condition
 * repasse à false (après reset/soumission).
 */
let dirty = false;

export const setFormDirty = (v) => { dirty = !!v; };
export const isFormDirty = () => dirty;

export const CONFIRM_EXIT_MESSAGE =
  'Des modifications non enregistrées seront perdues. Quitter quand même ?';

/** true = on peut quitter (rien à perdre, ou l'utilisateur confirme). */
export const confirmLeave = () => !dirty || window.confirm(CONFIRM_EXIT_MESSAGE);

export function useFormGuard(isDirty) {
  useEffect(() => {
    setFormDirty(isDirty);
    return () => setFormDirty(false);
  }, [isDirty]);

  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (!dirty) return undefined;
      e.preventDefault();
      e.returnValue = CONFIRM_EXIT_MESSAGE;
      return CONFIRM_EXIT_MESSAGE;
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, []);
}
